var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.16667 5.16669V23.8334M19.8333 5.16669V23.8334M3.5 9.83335H8.16667M19.8333 9.83335H24.5M3.5 14.5H24.5M3.5 19.1667H8.16667M19.8333 19.1667H24.5M4.66667 23.8334H23.3333C23.9777 23.8334 24.5 23.311 24.5 22.6667V6.33335C24.5 5.68902 23.9777 5.16669 23.3333 5.16669H4.66667C4.02233 5.16669 3.5 5.68902 3.5 6.33335V22.6667C3.5 23.311 4.02234 23.8334 4.66667 23.8334Z",
    stroke: "currentColor",
    strokeWidth: 1.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReel);
export default __webpack_public_path__ + "static/media/reel.eb06bee115f427d0a07c1f8d0099004e.svg";
export { ForwardRef as ReactComponent };